import { useEmployeeById } from '@/components/providers/v1-office-hooks';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

interface Props {
  employeeId: string | null | undefined;
}

export function EmployeeAvatar({ employeeId }: Props) {
  const employee = useEmployeeById(employeeId);
  return (
    <Avatar className='size-9 rounded-lg'>
      <AvatarImage src={employee?.avatar_url ?? undefined} />
      <AvatarFallback className='rounded-lg text-sm font-medium'>
        {employee?.first_name.charAt(0)}
        {employee?.last_name.charAt(0)}
      </AvatarFallback>
    </Avatar>
  );
}
